import React, { useContext, useEffect, useState } from "react";
import { Menu } from "../Menu";
import { MenuLateral } from "../MenuLateral";
import { Link } from "react-router-dom";
import { ModalAviso } from "../cuotas/ModalAviso";
import { AppContext } from "../../../../Context/Context";

export const Inicio = () => {
    const id = atob(sessionStorage.getItem("dtpln"));
    const [state, setState] = useContext(AppContext);
    const [descripcion, setdescripcion] = useState(null);
    const [cargaOferta, setCargaOferta] = useState('');
    const [avisoSelected, setAviso] = useState({});
    let info = null;
    let planes = null;
    let plan = null;
    let cuotasImpagas = [];
    let cuotasEmitidas = [];

    if (state.data !== null) {
        info = state.data.Usuario.Datos;
        planes = info.Planes.Plan;
        plan = planes.filter(plan => plan.Id === id)[0];
        cuotasImpagas =
            plan?.Cuotas?.Cuota?.filter(cuota => cuota.Estado == "Impaga").sort(
                (a, b) => {
                    if (a.Cuota > b.Cuota) return 1;
                    if (b.Cuota > a.Cuota) return -1;
                    return 0;
                }
            ) || [];
        cuotasEmitidas =
            plan?.Cuotas?.Cuota?.filter(
                cuota => cuota.Estado == "Emitida"
            ).sort((a, b) => {
                if (a.Cuota > b.Cuota) return 1;
                if (b.Cuota > a.Cuota) return -1;
                return 0;
            }) || [];
    }

    useEffect(() => {
        if (plan) {
            setState(prevState => ({ ...prevState, plan }));
        }
    }, [plan, setState]);

    let handleOpen = avisoSelected => {
        setAviso(avisoSelected);
        let backdrop = document.querySelector(".modalAvisoBackdrop");
        backdrop.classList.add("open");

        let form = document.querySelector(".modalAvisoScreen");
        form.classList.add("open");

        const optionsBodyScroll = {
            reserveScrollBarGap: true
        };

        disableBodyScroll(backdrop, optionsBodyScroll);

        console.log("click");
    };

    useEffect(() => {
        const asyncFunction = async () => {
            const endpoint = await (await fetch('/api/show_endpoints/listaCuotasPendientes')).json();
            console.log(endpoint.estado)
            if (endpoint.estado == 0) {
                setListaCuotasPendientes('pagar')
            } else {
                setListaCuotasPendientes(`${endpoint.url_base}${endpoint.url_variable}`)
            }
        }
        asyncFunction();
    }, []);

    let handleClose = () => {
        let backdrop = document.querySelector(".modalAvisoBackdrop");
        backdrop.classList.remove("open");

        let form = document.querySelector(".modalAvisoScreen");
        form.classList.remove("open");
        enableBodyScroll(backdrop);
    };

    // Cuotas para pagar
    let cuota_para_pagar = JSON.parse(localStorage.getItem("cuota_pagar"));
    if (!cuota_para_pagar) {
        cuota_para_pagar = [];
    }

    const isEnJuicio = state.selectedPlan?.EstadoPlan === "Adjudicado - EN JUICIO";

    let handlePagar = e => {
        localStorage.setItem("cuota_pagar", e);
    };

    const handleImprimir = async (url) => {
        await auditService();
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const auditService = async () => {
        try {
            const auditoriaServicioData = {
                marca: "ram",
                modo: "PDF",
                tipo_envio: "Descarga cuota",
                codigo_motivo: 4,
                motivo: "Aviso de Vencimiento",
                fecha_hora: new Date().toISOString(),
                cuit_cuil: atob(sessionStorage.getItem("dtdc"))
            };

            let response = await fetch("/api/post_auditoria_servicio", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(auditoriaServicioData)
            });

            response = await response.json();

            if (!response.success) {
                console.error("Error auditoría:", response);
            }
        } catch (err) {
            console.error("Error auditoría:", err);
        }
    };

    useEffect(() => {
        if (plan !== null) {
            fetch(`/planes_historicos/${plan.CodigoPlan}`)
                .then(res => res.json())
                .then(result => {
                    setdescripcion(result.descripcion);
                });
        }
    }, [plan]);

    useEffect(() => {
        const asyncFunction = async () => {
            const endpoint = await (await fetch('/api/show_endpoints/cargaoferta')).json();

            setCargaOferta(
                `${endpoint.url_base}${endpoint.url_variable}`
            )
        }
        asyncFunction();
    }, []);

    const [listaCuotasPendientes, setListaCuotasPendientes] = useState('')

    return (
        <>
            <div>
                <Menu />
                <div className="wrap">
                    <MenuLateral key={state.selectedPlan?.Id || "default-key"} />
                    <div className="next-to-sidebar">
                        {info !== null ? (
                            <div className="inicio">

                                <div className="inicio_mainDiv mt-dbhf">
                                    <div className="inicio_mainDiv--user">
                                        <p>{`${info.Nombre} ${info.Apellido}`}</p>
                                        <div className="separator--hor mt-half mb-half"></div>
                                    </div>
                                    <div className="inicio_mainDiv--estado">
                                        <div className="inicio_mainDiv--estado--box">
                                            <p className="inicio_mainDiv--estado--box--title">
                                                Estado
                                            </p>
                                            <div className="etiqueta_estado">
                                                {plan?.EstadoPlan}
                                            </div>
                                        </div>
                                        {plan?.Resumen?.Total !== 0 && (
                                            <>
                                                <div className="inicio_mainDiv--estado--box">
                                                    <p className="inicio_mainDiv--estado--box--cuotas">
                                                        Cuotas
                                                    </p>
                                                    <div className="progress">
                                                        <div
                                                            className="progress-bar"
                                                            role="progressbar"
                                                            style={{
                                                                width:
                                                                    (Math.round(
                                                                        (plan.Resumen
                                                                            .Pagas /
                                                                            plan.Resumen
                                                                                .Total) *
                                                                        100
                                                                    ) < 10
                                                                        ? 10
                                                                        : Math.round(
                                                                            (plan.Resumen
                                                                                .Pagas /
                                                                                plan
                                                                                    .Resumen
                                                                                    .Total) *
                                                                            100
                                                                        )) + "%"
                                                            }}
                                                            aria-valuenow={Math.round(
                                                                (plan.Resumen.Pagas /
                                                                    plan.Resumen.Total) *
                                                                100
                                                            )}
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                        >
                                                            {Math.round(
                                                                (plan.Resumen.Pagas /
                                                                    plan.Resumen.Total) *
                                                                100
                                                            )}
                                                            %
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <div className="separator--hor mt-base mb-half"></div>
                                    </div>
                                    {!isEnJuicio && (
                                    <div className="inicio_mainDiv--bloque mb-base">
                                        {cuotasImpagas.length > 0 &&
                                            cuotasImpagas.map(cuota => (
                                                <div className="inicio_mainDiv--bloque--div">
                                                    <div>
                                                        <p className="title">
                                                            CUOTA IMPAGA
                                                        </p>
                                                        <p className="subtitle">
                                                            Cuota {cuota.Cuota}
                                                        </p>
                                                        <ul>
                                                            <li>
                                                                Importe: ${" "}
                                                                {Number(
                                                                    cuota.Importe
                                                                ).toLocaleString("de-DE")}
                                                            </li>
                                                            <li>Estado: {cuota.Estado}</li>
                                                            <li>
                                                                vencimiento:{" "}
                                                                {cuota.Vencimiento}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    {
                                                        listaCuotasPendientes.startsWith('http') ? (
                                                            <a
                                                                href={listaCuotasPendientes}
                                                                className="link_pagar"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Pagar
                                                            </a>
                                                        ) : (
                                                            <Link
                                                                onClick={() => handlePagar(cuota.Cuota)}
                                                                className="link_pagar"
                                                                to={listaCuotasPendientes}
                                                            >
                                                                Pagar
                                                            </Link>
                                                        )
                                                    }
                                                </div>
                                            ))}
                                        {cuotasEmitidas.length > 0 &&
                                            cuotasEmitidas.map(cuota => (
                                                <div className="inicio_mainDiv--bloque--div">
                                                    <div>
                                                        <p className="title">
                                                            Próximo vencimiento
                                                        </p>
                                                        <p className="subtitle">
                                                            Cuota {cuota.Cuota}
                                                        </p>
                                                        <ul>
                                                            <li>
                                                                Importe: ${" "}
                                                                {Number(
                                                                    cuota.Importe
                                                                ).toLocaleString("de-DE")}
                                                            </li>
                                                            <li>Estado: {cuota.Estado}</li>
                                                            <li>
                                                                vencimiento:{" "}
                                                                {cuota.Vencimiento}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div style={{ display: "inline-flex" }}>
                                                        {
                                                            listaCuotasPendientes.startsWith('http') ? (
                                                                <a
                                                                    href={listaCuotasPendientes}
                                                                    className="link_pagar"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    Pagar
                                                                </a>
                                                            ) : (
                                                                <Link
                                                                    onClick={() => handlePagar(cuota.Cuota)}
                                                                    className="link_pagar"
                                                                    to={listaCuotasPendientes}
                                                                >
                                                                    Pagar
                                                                </Link>
                                                            )
                                                        }
                                                        <Link
                                                            onClick={() => handleOpen(cuota.AvisoVecimiento)}
                                                            className="link_pagar"
                                                            to="#"
                                                        >
                                                            Descargar Cuota
                                                        </Link>
                                                        <a
                                                            target="_blank" href="pdf/instructivos/Instructivo FIAT - COMO LEER MI CUOTA.pdf"
                                                            className="link_pagar"
                                                        >
                                                            ¿Como leer mi cuota?
                                                        </a>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                    )}
                                    {/* Solicitud Section */}
                                    <div className="datos_totalWidthDiv">
                                        <div className="datos_totalWidthDiv--div">
                                            <p>Solicitud</p>
                                        </div>
                                    </div>
                                    <div className="datos_mainDiv mt-0">
                                        <div className="datos_mainDiv--solicitud">
                                            <div className="datos_mainDiv--solicitud--div">
                                                <p>
                                                    <b>SOLICITUD:</b> {plan.Solicitud}
                                                </p>
                                            </div>
                                            <div className="datos_mainDiv--solicitud--div">
                                                <p>
                                                    <b>PLAN:</b>{" "}
                                                    {descripcion !== null &&
                                                        plan !== null &&
                                                        descripcion}
                                                </p>
                                            </div>
                                            <div className="datos_mainDiv--solicitud--div">
                                                <div className="tooltip--div">
                                                    <p>
                                                        <b>MODELO DE SUSCRIPCIÓN:</b>{" "}
                                                    </p>
                                                    <button
                                                        type="button"
                                                        className=""
                                                        data-toggle="tooltip"
                                                        data-placement="left"
                                                        title="Modelo al que te suscribiste al inicio de tu plan."
                                                    >
                                                        i
                                                    </button>
                                                </div>
                                                <p>{plan.ModeloSuscripcion}</p>
                                            </div>
                                            <div className="datos_mainDiv--solicitud--div">
                                                <div className="tooltip--div">
                                                    <p>
                                                        <b>MODELO DE AHORRO:</b>{" "}
                                                    </p>
                                                    <button
                                                        className=""
                                                        data-toggle="tooltip"
                                                        data-placement="left"
                                                        title="Modelo sobre el cual estás pagando tu plan actualmente."
                                                    >
                                                        i
                                                    </button>
                                                </div>
                                                <p>{plan.ModeloAhorro}</p>
                                            </div>
                                            <div className="datos_mainDiv--solicitud--div">
                                                <div className="tooltip--div">
                                                    <p>
                                                        <b>MODELO RETIRADO:</b>{" "}
                                                    </p>
                                                    <button
                                                        className=""
                                                        data-toggle="tooltip"
                                                        data-placement="left"
                                                        title="Modelo ya facturado a tu nombre."
                                                    >
                                                        i
                                                    </button>
                                                </div>
                                                <p>{plan.ModeloRetirado}</p>
                                            </div>
                                            <div className="datos_mainDiv--solicitud--div">
                                                <p>
                                                    <b>CONCESIONARIO ACTUAL:</b>{" "}
                                                </p>
                                                <p>{plan.ConcesionarioActual}</p>
                                                <a
                                                    className="text-rojo"
                                                    target="_blank"
                                                    href="https://fiat-ar-prod-fca.adobecqms.net/concesionarios.html"
                                                >
                                                    Datos del concesionario
                                                </a>
                                            </div>
                                            <div className="datos_mainDiv--solicitud--div">
                                                <p>
                                                    <b>SEGURO DE VIDA:</b>
                                                </p>
                                                <p>{plan.SeguroDeVida}</p>
                                            </div>
                                            <div className="datos_mainDiv--solicitud--div">
                                                <p>
                                                    <b>ENTE RECAUDADOR:</b>{" "}
                                                    {plan.EnteRecaudador}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="spinner-loader">
                                <div
                                    className="spinner-border text-bordo mt-dbhf mb-doub align-self-center"
                                    role="status"
                                >
                                </div>
                            </div>

                        )}
                    </div>
                </div>
            </div>
            <ModalAviso handleClose={handleClose}>
                <div className="modalContainer">
                    {Object.keys(avisoSelected).length > 0 &&
                        avisoSelected.Aviso.map(campo =>
                            campo.Etiqueta !== "Imprimir" ? (
                                campo.Etiqueta == "Grupo/Orden:" ||
                                    campo.Etiqueta == "Vencimiento:" ||
                                    campo.Etiqueta == "Comprobante:" ? (
                                    <div>
                                        <b>{campo.Etiqueta} </b>
                                        {campo.Valor}
                                    </div>
                                ) : (
                                    <div>
                                        <b>{campo.Etiqueta}</b>
                                        {" $ " +
                                            Number(campo.Valor).toLocaleString(
                                                "de-DE"
                                            )}
                                    </div>
                                )
                            ) : (
                                <button
                                    type="button"
                                    className="buttonModalMob"
                                    onClick={() => handleImprimir(campo.Valor)}
                                >
                                    <span>Imprimir</span>
                                </button>
                            )
                        )}
                </div>
            </ModalAviso>
        </>
    );
};
